import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  ClickAwayListener,
  FormControlLabel,
  Grid,
  Grow,
  Hidden,
  IconButton,
  InputAdornment,
  MenuItem,
  MenuList,
  Paper,
  Radio,
  RadioGroup,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from "@material-ui/core";
import moment from "moment";
import esLocale from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { makeStyles } from "@material-ui/core/styles";
import { useForm } from "../../../../hooks/useForm";
import { Notifications, Search } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  BuscadorBandejaPorAfiliado,
  BuscadorBandejaPorIdReclamo,
  TraerReclamos,
  TraerTipoComentarios,
  cleanDocumentacionReclamos,
  desSeleccionarAfiliado,
  setEstadoSolicitudesReclamos,
} from "../../../../actions/reclamos/reclamosActions";
import { RECLAMOS_ESTADOS } from "../../../../utils/constants";
import { ReclamoItem } from "../ModalIngresoReclamo/ReclamoItem";
import Buscador from "../../../../actions/ui/Buscador";
import Poppers from "@material-ui/core/Popper";
import classNames from "classnames";




const useStyles = makeStyles({
  root: {
    padding: 10,
    flexGrow: 1,
    marginTop: 10,
    // width: "100%",
  },
  input: {
    // padding: 10,
    paddingLeft: 10,
    paddingRight: 10,
  },
  buscador: {
    padding: 8,
  },
});

const today = new Date();
const threeMonthsAgo = new Date(today);
threeMonthsAgo.setMonth(today.getMonth() - 3);

const stateInitial = {
  idProfesional: "",
  fechaInicio: threeMonthsAgo,
  fechaFin: today,
};

export const GestionReclamos = (props) => {
  const classes = useStyles();
  const [formValues, , , setearValor] = useForm(stateInitial);
  const dispatch = useDispatch();
  const { fechaInicio, fechaFin } = formValues;
  const { estadoSolicitudes, items } = useSelector(
    (state) => state.reclamos
  );
  const { areasFisicasUsuario } = useSelector((state) => state.auth);
  const [idReclamo, setIdReclamo] = useState(null);
  const [value, setValue] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [dense, setDense] = useState(true);
  const [page, setPage] = useState(0);
  const [openNotification, setOpenNotification] = React.useState(null);
  const [notificaciones, setNotificaciones] = useState([])
  const [notificados, setNotificados] = useState([]);


  const mostrarNot = notificaciones.length > 0 ? true : false;

  const tipoBusqueda = "Todos";
  const altaBaja = "Todos";

  const isSearchingRef = useRef(false);

  const fetchData = () => {
    if (!isSearchingRef.current) {
      dispatch(TraerReclamos(estadoSolicitudes, areasFisicasUsuario.idArea, areasFisicasUsuario.idSubArea, fechaInicio, fechaFin));
      dispatch(cleanDocumentacionReclamos());
      dispatch(TraerTipoComentarios());
    }
  };


  useEffect(() => {


    fetchData();

    // Establecer un intervalo de 30 segundos y ejecutar la función en cada intervalo
    const interval = setInterval(() => {
      fetchData();
    }, 30000);

    // Limpiar el intervalo al desmontar el componente o cuando los valores cambien
    return () => clearInterval(interval);
  }, [dispatch, estadoSolicitudes, fechaInicio, fechaFin, areasFisicasUsuario.idArea, areasFisicasUsuario.idSubArea]);

  useEffect(() => {
    if (value?.nro_doc > 0) {
      dispatch(desSeleccionarAfiliado());
      dispatch(
        BuscadorBandejaPorAfiliado(
          value.nro_doc,
          areasFisicasUsuario.idArea,
          areasFisicasUsuario.idSubArea,
          estadoSolicitudes,
          fechaInicio,
          fechaFin
        )
      );
    }

  }, [value]);



  const arrayEstadosSolicitudes = Object.entries(RECLAMOS_ESTADOS);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const componentRef = React.useRef();

  useEffect(() => {
    // Identificamos nuevos casos en items que no estén ya en otroArray
    const nuevosCasos = items.filter((item) => item.estado === parseInt(estadoSolicitudes) && !notificados.includes(item.id));

    if (nuevosCasos.length > 0) {
      setNotificaciones((prevArray) => [...prevArray, ...nuevosCasos]);
      setNotificados((prevNotificados) => [
        ...prevNotificados,
        ...nuevosCasos.map((caso) => caso.id),
      ]); // Actualizar historial de notificados
    }
  }, [items, notificados]); // Se ejecuta cuando 'items' cambia

  const handleClickNotification = event => {
    if (openNotification && openNotification.contains(event.target)) {
      setOpenNotification(null);

    } else {
      setOpenNotification(event.currentTarget);
    }
  };

  const handleCloseNotification = () => {
    setOpenNotification(null);
  };

  const handleGoNotification = (log) => {
    setNotificaciones((prevArray) => prevArray.filter((caso) => caso.id !== log.id));
  }

  const handleLeerTodo = () => {
    setNotificaciones([]); // Vacía las notificaciones visibles
    setNotificados((prev) =>
      prev.concat(
        notificaciones
          .filter((notificacion) => notificacion.estado === parseInt(estadoSolicitudes))
          .map((notificacion) => notificacion.id)
      )
    ); // Mantén un registro de las notificaciones leídas
  };



  return (
    <Grid container className={classes.root} justify="center" spacing={1}>
      <Grid item xs={12}>
        <Grid container direction="row" alignItems="center" spacing={1}>
          <Grid item xs={12} md={4}>
            <Paper className={classes.buscador} >
              <Buscador
                value={value}
                variant="outlined"
                setValue={(val) => setValue(val)}
                label="Apellido y Nombre  |  CUIT  |  DNI  |  Numero Beneficiaria/o"
                noOptionText={"No se encuentra beneficiaria/o"}
                endpoint={(texto) =>
                  `Afiliados/traerPorNombreoDNIoNroAfi/${texto}/${tipoBusqueda}/${altaBaja}`
                }
                getOptionLabel={(option) =>
                  `${option.apellido_y_nombre} ${option.carnet} ${option.cuil} ${option.nro_doc}`
                }
                renderOption={(option) => (
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span
                      style={
                        option.fecha_baja === null
                          ? { color: "green" }
                          : { color: "red" }
                      }
                    >
                      {`${option.apellido_y_nombre}`}
                    </span>
                    <span
                      style={{
                        fontSize: 12,
                      }}
                    >
                      {" "}
                      {`Nro Afi:${option.carnet} - CUIL:${option.cuil}`}
                    </span>
                  </div>
                )}
              />
              {/* <TextField
                margin="normal"
                fullWidth
                type="number"
                label="Buscar Por DNI"
                name="nroDocumento"
                value={nroDocumento}
                autoComplete="off"
                onChange={(e) => setNroDocumento(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      style={{ marginTop: -25, marginRight: -10 }}
                    >
                      <IconButton
                        aria-label="Buscar"
                        onClick={() => {
                          dispatch(BuscarAfiliadoPorDNI(nroDocumento));
                          dispatch(
                            BuscadorBandejaPorAfiliado(
                              nroDocumento,
                              areasFisicasUsuario.idArea,
                              areasFisicasUsuario.idSubArea,
                              estadoSolicitudes,
                             fechaInicio, 
                             fechaFin
                            )
                          );
                        }}
                      >
                        <Search />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              /> */}
            </Paper>
          </Grid>
          <Grid item xs={12} md={4}>
            <Paper className={classes.input}>
              <TextField
                margin="normal"
                fullWidth
                type="number"
                label="Id caso"
                name="idReclamo"
                value={idReclamo}
                autoComplete="off"
                onChange={(e) => setIdReclamo(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      style={{ marginTop: -25, marginRight: -10 }}
                    >
                      <IconButton
                        aria-label="Buscar"
                        onClick={() => {
                          if (idReclamo) {
                            isSearchingRef.current = true;
                            dispatch(
                              BuscadorBandejaPorIdReclamo(
                                idReclamo,
                                areasFisicasUsuario.idArea,
                                areasFisicasUsuario.idSubArea,
                                estadoSolicitudes,
                                fechaInicio,
                                fechaFin
                              )
                            );
                          } else {
                            // If idReclamo is empty, reset isSearchingRef and allow the regular data fetch
                            isSearchingRef.current = false;
                            fetchData();  // Trigger the data fetch manually
                          }
                        }}
                      >
                        <Search />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Paper>
          </Grid>
          <Grid item xs={12} md={2}>
            <Paper className={classes.input}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  label="Fecha Inicio"
                  format="dd/MM/yyyy"
                  // required={true}
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  value={
                    moment(fechaInicio).isValid() ? moment(fechaInicio).format() : null
                  }
                  onChange={(date) => {
                    setearValor("fechaInicio", date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </MuiPickersUtilsProvider>
            </Paper>
          </Grid>
          <Grid item xs={12} md={2}>
            <Paper className={classes.input}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  label="Fecha Fin"
                  format="dd/MM/yyyy"
                  // required={true}
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  value={moment(fechaFin).isValid() ? moment(fechaFin).format() : null}
                  onChange={(date) => {
                    setearValor('fechaFin', date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </MuiPickersUtilsProvider>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <div className={classes.manager}>
          <Button
            aria-owns={openNotification ? "notification-menu-list-grow" : null}
            aria-haspopup="true"
            onClick={handleClickNotification}
            className={classes.buttonLink}
          >
            <Notifications className={classes.icons} style={{ color: "#FAFAFA" }} />
            {mostrarNot && notificaciones?.length > 0 && (
              <span className={classes.notifications}>{notificaciones?.length}</span>
            )}
            <Hidden mdUp implementation="css">
              <p onClick={handleCloseNotification} className={classes.linkText}>
                Notification
              </p>
            </Hidden>
          </Button>
          {mostrarNot && notificaciones?.length > 0 && (
            <Poppers
              open={Boolean(openNotification)}
              anchorEl={openNotification}
              transition
              disablePortal={false}
              className={
                classNames({ [classes.popperClose]: !openNotification }) +
                " " +
                classes.popperNav
              }
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  id="notification-menu-list-grow"
                  style={{
                    transformOrigin:
                      placement === "bottom" ? "center top" : "center bottom",
                  }}
                >
                  <Paper>
                    <ClickAwayListener onClickAway={handleCloseNotification}>
                      <MenuList role="menu">
                        {/* Mapear notificaciones */}
                        {notificaciones.map((log) => (
                          <MenuItem
                            key={log.id}
                            onClick={() => {
                              handleGoNotification(log);
                            }}
                            className={classes.dropdownItem}
                          >
                            Id {log.id} - Sec {log.descripcionSeccional} - Estado: 
                            {log.descripcionEstado}
                          </MenuItem>
                        ))}
                        {/* Botón Leer Todo */}
                        <MenuItem
                          onClick={handleLeerTodo}
                          className={classes.dropdownItem}
                          style={{
                            fontWeight: "bold",
                            textAlign: "center",
                            color: "#FF5722",
                          }}
                        >
                          Leer todo
                        </MenuItem>
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Poppers>
          )}
        </div>
      </Grid>
      <Grid item xs={12}>
        <Paper style={{ padding: "0.25rem", marginTop: -5 }}>
          <RadioGroup
            row
            style={{ justifyContent: "space-around" }}
            value={estadoSolicitudes}
            onChange={(e) => {
              dispatch(setEstadoSolicitudesReclamos(e.target.value));
            }}
          >
            {arrayEstadosSolicitudes.map((estadoSolicitud, index) => {
              //const contador = solicitudesContadores.find(s => s.estado === estadoSolicitud[1]);
              const label =
                estadoSolicitud[0].charAt(0) +
                estadoSolicitud[0].replace("_", " ").toLowerCase().slice(1);
              // +
              // ((!!contador)
              //   ?
              //     `(${contador.totalItems})`
              //   :
              //     `(...)`
              // );
              return (
                <FormControlLabel
                  key={index}
                  style={{ marginLeft: "0.5rem" }}
                  label={label}
                  value={estadoSolicitud[1]?.toString()}
                  control={<Radio />}
                />
              );
            })}
          </RadioGroup>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <TableContainer component={Paper} style={{ overflowX: "auto" }}>
          <Table size={dense ? "small" : "medium"} ref={componentRef}>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell align="left">Semáforo</TableCell>
                <TableCell align="left">Estado</TableCell>
                {parseInt(estadoSolicitudes) === RECLAMOS_ESTADOS.PENDIENTE ? (
                  <TableCell align="left">Fecha Carga</TableCell>
                ) : (
                  <TableCell align="left">Fecha Enviada</TableCell>
                )}
                <TableCell align="left">Id</TableCell>
                <TableCell align="left">Nro Beneficiaria/o</TableCell>
                <TableCell align="left">Apellido y Nombre</TableCell>
                <TableCell align="left">Tipo</TableCell>
                <TableCell align="left">Origen</TableCell>
                <TableCell align="left">Categoría</TableCell>
                {/* <TableCell align="left">Derivado</TableCell> */}
                <TableCell align="left">Seccional</TableCell>
                {/* <TableCell align="left">Tomada</TableCell> */}
                <TableCell align="left">Área derivado</TableCell>
                <TableCell align="left">Subárea derivado</TableCell>
                {parseInt(estadoSolicitudes) === RECLAMOS_ESTADOS.FINALIZADA && (
                  <TableCell align="left">Origen del error</TableCell>
                )}
                {(parseInt(estadoSolicitudes) === RECLAMOS_ESTADOS.FINALIZADA ||
                  parseInt(estadoSolicitudes) === RECLAMOS_ESTADOS.ANULADA) && (
                    <TableCell align="left">Detalle</TableCell>
                  )}

                {/* {parseInt(estadoSolicitudes) === RECLAMOS_ESTADOS.PENDIENTE && (
                  <TableCell align="left">Datos</TableCell>
                )} */}
                <TableCell align="left">Tomada</TableCell>
                <TableCell align="left"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.length > 0 ? (
                // items.map((item) => (
                items
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item) => (
                    <ReclamoItem
                      item={item}
                      //setRedirect={setRedirect}
                      //permisosUser={permisosUser}
                      key={item.id?.toString()}
                      estadoSolicitudes={estadoSolicitudes}
                      fechaFin={fechaFin}
                      fechaInicio={fechaInicio}
                      areasFisicasUsuario={areasFisicasUsuario}
                      {...props}
                    />
                  ))
              ) : (
                <TableRow style={{ height: 50 }}>
                  <TableCell
                    colSpan={13}
                    style={{ textAlign: "-webkit-center" }}
                  >
                    {" "}
                    Sin Registros
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      {items.length > 0 && (
        <Grid item xs={12}>
          <TablePagination
            style={{ backgroundColor: "white" }}
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={items.length}
            rowsPerPage={rowsPerPage}
            labelRowsPerPage="Registros por página"
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
          <FormControlLabel
            control={
              <Switch
                checked={dense}
                onChange={(e) => setDense(e.target.checked)}
              />
            }
            label="Tamaño compacto"
          />
        </Grid>
      )}
      {/* {redirect && (
        <Redirect
          to={{
            pathname: '/autorizaciones',
            state: {
              from: '/autorizaciones/gestion'
            },
          }}
        />
      )} */}
    </Grid>
  );
};
